import { VariantProps } from 'class-variance-authority';
import { ElementType, FC, ReactNode } from 'react';

import { SectionConfigProps } from 'molecules/Section/config';
import sectionStyles from 'molecules/Section/styles';
import { getBackgroundStyle } from 'molecules/Section/styles/getBackgroundStyle';

interface SectionProps extends MergePrefer<VariantProps<typeof sectionStyles>, SectionConfigProps> {
  as?: ElementType;
  noBackground?: boolean;
  children?: ReactNode;
  bare?: boolean;
  sidePadding?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | 'default';
  tealBackground?: boolean;
}

const Section: FC<SectionProps> = ({
  as,
  id,
  paddingTop,
  paddingBottom,
  darkMode,
  nextComponentIsDark,
  children,
  hasGradientTransition,
  dottedBackground,
  flareBackground,
  flareBackgroundTop,
  noBackground,
  noContain,
  bare,
  noDarkMode,
  hasLinearGradientTransition,
  sidePadding = 'default',
  hasGradientDark,
  hasGradientTransitionTop,
  hasGradientTransitionTopBanner,
  tealBackground,
}) => {
  const Component = as || 'section';

  const backgroundStyle = getBackgroundStyle({
    flareBackground: flareBackground || false,
    flareBackgroundTop: flareBackgroundTop || false,
    dottedBackground: dottedBackground || false,
  });

  const innerPaddingClass = sidePadding === 'none' ? 'px-0' : 'px-4 sm:px-16 lg:px-8';

  return (
    <Component
      id={id}
      style={backgroundStyle}
      className={sectionStyles({
        paddingTop,
        paddingBottom,
        nextComponentIsDark,
        darkMode,
        hasGradientTransition,
        hasGradientTransitionTop,
        hasGradientTransitionTopBanner,
        dottedBackground: dottedBackground && !flareBackground,
        flareBackground,
        flareBackgroundTop,
        noBackground,
        noContain,
        noDarkMode,
        hasLinearGradientTransition,
        sidePadding,
        hasGradientDark,
        tealBackground,
      })}
    >
      {hasGradientTransitionTop && (
        <div
          className="
        pointer-events-none absolute left-0 top-0 h-48
        w-full
        bg-hasGradientTransitionTop
      "
        />
      )}

      {hasGradientTransitionTopBanner && (
        <div
          className="
      pointer-events-none absolute left-0 top-0 
      h-48
      w-full
      bg-hasGradientTransitionTopBanner 
    "
        />
      )}

      {bare ? children : <div className={`mx-auto max-w-screen-xl ${innerPaddingClass}`}>{children}</div>}
    </Component>
  );
};

export default Section;
